module.exports = __webpack_public_path__ + "media/dashboard/components/widgets/conversation/icon/helpIcon-5879774a480f3c83ae4482d1124da955.svg";